import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1416.01293,791.915394 L1385.10341,1017.53231 L1013.85076,1017.53231 L1013.85076,1807.19154 L788.233843,1807.19154 L788.233843,1017.53231 L449.808461,1017.53231 L449.808461,791.915394 L788.233843,791.915394 L788.233843,585.137485 C788.233843,298.26557 964.440658,112.808461 1237.32432,112.808461 C1354.19389,112.808461 1427.06816,119.012926 1469.14571,124.653349 L1465.87427,338.312573 L1292.37485,338.650999 C1287.6369,338.199765 1174.60282,329.400705 1093.0423,404.305523 C1040.47356,452.474736 1013.85076,521.73913 1013.85076,609.955347 L1013.85076,791.915394 L1416.01293,791.915394 Z M1168.73678,487.896592 C1213.18331,446.495887 1282.44771,451.008226 1287.52409,451.233843 L1576.9906,451.121034 L1583.19506,33.6169213 L1539.651,22.9001175 C1511.6745,16.0188014 1426.05288,0 1237.32432,0 C901.26792,0 675.425382,235.20564 675.425382,585.137485 L675.425382,679.106933 L337,679.106933 L337,1130.34078 L675.425382,1130.34078 L675.425382,1920 L1126.65922,1920 L1126.65922,1130.34078 L1483.35958,1130.34078 L1545.29142,679.106933 L1126.65922,679.106933 L1126.65922,609.955347 C1126.65922,555.017626 1140.87309,513.955347 1168.73678,487.896592 L1168.73678,487.896592 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconFacebookLine = /*#__PURE__*/function (_Component) {
  _inherits(IconFacebookLine, _Component);

  var _super = _createSuper(IconFacebookLine);

  function IconFacebookLine() {
    _classCallCheck(this, IconFacebookLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconFacebookLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconFacebook",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconFacebookLine.displayName = "IconFacebookLine";
  return IconFacebookLine;
}(Component);

IconFacebookLine.glyphName = 'facebook';
IconFacebookLine.variant = 'Line';
IconFacebookLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconFacebookLine;
export { IconFacebookLine };